import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=1b8abb9b&scoped=true&"
import script from "./product_list.vue?vue&type=script&lang=js&"
export * from "./product_list.vue?vue&type=script&lang=js&"
import style0 from "./product_list.vue?vue&type=style&index=0&id=1b8abb9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8abb9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b8abb9b')) {
      api.createRecord('1b8abb9b', component.options)
    } else {
      api.reload('1b8abb9b', component.options)
    }
    module.hot.accept("./product_list.vue?vue&type=template&id=1b8abb9b&scoped=true&", function () {
      api.rerender('1b8abb9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/tasting_wine_management/price_maintenance/form/product_list.vue"
export default component.exports